import React from 'react'
import {Switch, Route} from 'react-router-dom'
import UpdateForm from './components/routeComponents/UpdateForm'

function Routes() {
    return (
        <>
            <div className="cursor"></div>
           <Switch>
               <Route path="/update">
                   <UpdateForm />
               </Route>
           </Switch> 
        </>
    )
}

export default Routes
